const hardwareSPA = [
    {
        selector: '[data-react="hardware-spa"]',
        path: { filename: 'App' },
    },
];

export { hardwareSPA };
